import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useTranslation } from 'react-i18next';

export default function TemplateBuilderCard({ onClick }) {
  const { t } = useTranslation('homepage');
  const features = [t('templateBuilder.stepGuide'), t('templateBuilder.livePreview'), t('templateBuilder.yamlExport')];
  return (
    <Card
      sx={{
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 12px 24px rgba(102, 126, 234, 0.4)',
        },
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: 2,
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BuildIcon sx={{ fontSize: 32 }} />
          </Box>
          <AutoAwesomeIcon
            sx={{
              ml: 'auto',
              fontSize: 24,
              opacity: 0.8,
            }}
          />
        </Box>

        <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
          {t('templateBuilder.title')}
        </Typography>

        <Typography variant="body2" sx={{ opacity: 0.95, mb: 2 }}>
          {t('templateBuilder.description')}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {features.map((feature) => (
            <Box
              key={feature}
              sx={{
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.75rem',
                fontWeight: 500,
              }}
            >
              {feature}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
